import { Image } from 'expo-image';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

import { NavigationButton, NavigationButtonTypes } from '../navigation-button';

const mapImageSrc = require('../../../public/images/map.png');

interface DeliveryFeeModalProps {
  visible?: boolean;
  onClose?: () => void;
  style?: any;
}

export function DeliveryFeeModal({
  visible = false,
  onClose,
  style,
}: DeliveryFeeModalProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [showHowDeliveryFeesModal, setShowHowDeliveryFeesModal] =
    useState(visible);

  useEffect(() => {
    setShowHowDeliveryFeesModal(visible);
  }, [visible]);

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={300}
      isVisible={showHowDeliveryFeesModal}
      hasBackdrop
      style={{
        ...styles.container,
        ...style,
      }}
      onBackdropPress={() => {
        setShowHowDeliveryFeesModal(false);
        onClose?.();
      }}
    >
      <View
        style={{
          backgroundColor: theme.colors.background_2,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          gap: 24,
          borderRadius: 16,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: 16,
          }}
        >
          <Text type="title2">Delivery Fee</Text>

          <NavigationButton
            type={NavigationButtonTypes.cancel}
            onPress={() => {
              setShowHowDeliveryFeesModal(false);
              onClose?.();
            }}
            style={{
              position: 'absolute',
              right: 16,
              top: 16,
            }}
          />
        </View>

        <View>
          <Image
            source={mapImageSrc}
            contentFit="cover"
            style={{
              width: '100%',
              height: 250,
            }}
          />
        </View>

        <View
          style={{
            padding: 16,
            paddingTop: 0,
            gap: 8,
          }}
        >
          <View style={{ gap: 8 }}>
            <Text type="title2">How Do Delivery Fees Work?</Text>

            <View style={{ gap: 8 }}>
              <Text type="bodyRegular">
                Delivery and Return Fees are based on the car's location,
                distance to the delivery address, and return trip back to the
                car's original spot.
              </Text>

              <Text type="bodyRegular">
                Only one delivery fee is charged, covering both delivery and
                return costs.
              </Text>
            </View>
          </View>

          <View style={{ gap: 8 }}>
            <Text type="bodyBold">Delivery fees calculated:</Text>

            <Text>$150 base fee up to 5 mi</Text>

            <Text>6-30 mi: $5/mi + base fee</Text>

            <Text>{'>'} 30 mi: $2.5/mi + base fee</Text>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    margin: 0,
    alignItems: 'center',
    justifyContent: {
      xs: 'flex-end',
      md: 'center',
    },
    alignSelf: 'center',
    maxWidth: {
      xs: '100%',
      sm: 600,
      md: 800,
    },
    width: {
      xs: '100%',
      md: 700,
    },
  },
}));
